import { DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import { PmiDialog } from 'shell/components/shared/dialog';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

interface CancelDialogProps {
  isOpen: boolean;
  onAbort: () => void;
  onConfirm: () => void;
  onClose: () => void;
}

const CancelDialog = ({
  isOpen,
  onAbort,
  onClose,
  onConfirm,
}: CancelDialogProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="close-modal"
      aria-describedby="close-modal"
      fullScreen={fullScreen}
      fullWidth
    >
      <PmiDialogTitle id="close-modal-title" backgroundColor="primary" color="white">
        Annulla Operazione
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        {
          "Attenzione, è stato cliccato il bottone di annulla pratica. Confermando l'operazione viene annullata e i dati immessi andranno inseriti nuovamente."
        }
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="cdmBrand" type="button" onClick={onConfirm}>
          Conferma
        </PmiButton>
        <PmiButton variant="outlined" color="primary" type="button" onClick={onAbort}>
          Annulla
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

CancelDialog.displayName = 'Cancel dialog';

export default CancelDialog;
